import { Box, Table, Thead, Tbody, Tr, Th, Td, Text } from '@chakra-ui/react';
import c from '../../../constant';

function RiskMatrixTable() {
	const bgHeader = '#CFEEC3';
	const bgBody = '#E6F8DD';

	const riskRows = [
		{ level: 'Level 0', code: '0.00', score: '', status: 'No business', boxBg: '#5A8F3D', textColor: 'black' },
		{ level: 'Level 1', code: '1.00', score: '> 0, <= 1', status: 'No concerns/Minimal', boxBg: '#B3B34A', textColor: 'black' },
		{ level: 'Level 2', code: '2.00', score: '> 1, <= 2', status: 'Some Concerns', boxBg: '#F4CF62', textColor: 'black' },
		{ level: 'Level 3', code: '3.00', score: '> 2, <= 3', status: 'Significant Concerns', boxBg: '#F28E5E', textColor: 'black' },
		{ level: 'Level 4', code: '4.00', score: '> 3', status: 'High Priority', boxBg: '#E45A4F', textColor: 'black' },
	];

	const cell = {
		border: '1px solid black',
		fontSize: '14px',
		backgroundColor: bgBody,
		padding: '0 0 0 3px',
	};

	const headCell = {
		...cell,
		backgroundColor: bgHeader,
		fontWeight: 'extrabold',
		textAlign: 'center',
	};

	return (
		<Box w="100%">
			<Box border="0.5px solid black" overflow="hidden" borderRadius={c.borderRadius}>
				<Table variant="unstyled">
					<Thead>
						<Tr>
							<Th {...headCell}>Risk level</Th>
							<Th {...headCell}>Risk Code</Th>
							<Th {...headCell}>Score</Th>
							<Th {...headCell}>Status</Th>
						</Tr>
					</Thead>
					<Tbody pl={5}>
						{riskRows?.map((r) => (
							<Tr key={r.level}>
								<Td {...cell}>{r.level}</Td>
								<Td {...cell} bg={r.boxBg} color={r.textColor} textAlign="center" fontWeight="bold">
									{r.code}
								</Td>
								<Td {...cell}>{r.score}</Td>
								<Td {...cell}>{r.status}</Td>
							</Tr>
						))}
					</Tbody>
				</Table>
			</Box>

			<Text mt={1} fontStyle="italic" fontSize="sm" textAlign="center">
				*In Active and In Rehabilitation – No taken action
			</Text>
		</Box>
	);
}

export default RiskMatrixTable;
